import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
	WithStyles,
	createStyles,
	Button,
	Typography,
	Grid,
} from '@material-ui/core';
import { initialNotesData } from '../types/ContentForNotesDefault';


import { MyPATLink, MyPATDialog } from '../../common';


import ContentData from '../types/ContentData';
import { UserData } from '../types/ContentData';
import userService from '../services/userService';
import { usersList } from '../actions/userActions';
import { checkForTeacherUser, getPropertyValue, removeContentId } from '../../../utils';
import getDefaultFormData from '../types/ContentFromDataDefault';
import contentService from '../services/contentService';
import ContentSubtypeData from '../types/ContentSubtypeData';
import contentSubtypeActions from '../actions/contentSubtypeActions';
import { getTypeOfNotes } from '../helper/notesPayload';
import { CONTENT_SECTION_KEYS, CONTENT_TYPE, titleCase } from '../../../constants/comman';

const styles = (theme: Theme) => createStyles({
	root: {
		display: 'flex',
		flexWrap: 'wrap',
	},
	checkImage: {
		margin: '30px auto 20px',
		display: 'block',
	}
});


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250,
		},
	},
};


//@ts-ignore
interface Props extends WithStyles<typeof styles> {
	classes: any,
	queryParams: any,
	history: any,
	content: any,
	isPublishedDialogOpen: boolean,
	users: UserData[],
	usersList: Function,
	fromURL: any,
	togglePublishDialogOpen: Function,
	authors: any,
	questionId: any,
	contentSubtype: {
		list: ContentSubtypeData[],
		question: ContentSubtypeData[],
		testpapers: ContentSubtypeData[],
		error: string | null,
	},
	rePublishContentId: string,
	userData: any,
	draftIdForQuestion: any,
	publishId: string,
	contentSubtypeByContentTypeCode: (code: string) => void;
	headingText?: string,
	bodyText?: string,
	fromQuestion?: boolean
}
interface States {
	// users: UserData[],

}

class ContentPublishedModal extends Component<Props, States> {
	state = {
		// users: [],
	};

	constructor(props: Props) {
		super(props);
		this.getAuthors = this.getAuthors.bind(this);
	}


	componentDidMount() {
		const { contentSubtype } = this.props;
		_.isEmpty(this.props.users) && this.props.usersList();
		const { type } = this.props.queryParams;
		if(type === 'question' && _.isEmpty(contentSubtype.question)) {
				this.props.contentSubtypeByContentTypeCode('question')
		} else if (type === 'testpapers' && _.isEmpty(contentSubtype.testpapers)) {
			this.props.contentSubtypeByContentTypeCode('testpapers');
		}
	}
	getAuthors() {
		let authorName = "";
		
		try{
			let { users, authors, userData } = this.props;
			if (authors.length === 0 || !authors[0]) {
				authorName += ` ${userData.authenticatedUser.email}`
			} else {
				authors[0].forEach((author: any, i: number) => {
					let authordata = _.find(users, user => user._id == author);
					if (authordata) {
						if (authordata.fullName) {
							authorName += `, ${authordata.fullName}`;
						} else {
							authorName += `, ${authordata.email}`;
						}
					}
				})
			}
		}catch(err){
			let { userData } = this.props;
			authorName += ` ${userData.authenticatedUser.email}`
		}

		return authorName
	}
	render() {
		let { subType, type } = this.props.queryParams;
		const { classes, content, draftIdForQuestion, publishId, isPublishedDialogOpen, rePublishContentId, users, fromURL, togglePublishDialogOpen, authors, headingText, bodyText } = this.props;
		let contentId = content.contentId
		if (content.draftId || draftIdForQuestion || publishId) {
			contentId = rePublishContentId ? rePublishContentId : content.contentId;
		}
		let createLink = `/content/create/${type}/${subType}`;
		let backTo: any = ""
		let fromTest = false;

		const noteSubType = _.get(this.props.content, 'content.subType', ''); 
		const urlParams = new URLSearchParams(fromURL);

		if (urlParams.has('refUrl') && fromURL.includes('testpapers')) {
			backTo = urlParams.get('refUrl');
			fromTest = true;
		}

		if (type == "studymaterial" && subType != "notes") {
			type = subType;
		}
		if(type === 'formulas' && subType === 'formulas'){
			type = 'studymaterial';
		}
		let authorsName: any = this.getAuthors()


		if (type == "question") {
			const { questionId } = this.props;
			const sectionIndex = urlParams.get('sectionIndex');
			const subSectionIndex = urlParams.get('subSectionIndex');
			const autoFillConcepts = urlParams.get('autoFillConcepts');
			backTo += `/?questionId=${questionId}&sectionIndex=${sectionIndex}&subSectionIndex=${subSectionIndex}&autoFillConcepts=${autoFillConcepts}`;
		}
		const isQuestion = checkForTeacherUser(content);

		return (
			<div>
				<MyPATDialog
					dialogOpen={isPublishedDialogOpen}
					otherDialogProps={{
						fullWidth: true,
						maxWidth: 'sm',
					}}
				>
					<img src="/assets/img/mylibrary/publish.png" className={classes.checkImage} />
					<Typography variant="body2" align="center">{headingText || 'Content Published Successfully'}</Typography>
					<Typography variant="caption" align="center">{bodyText || `Congratulations! The ${type} "${contentId}"  is published successfully by author "${authorsName}".`}</Typography>
					<div style={{ marginTop: '18px', marginBottom: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '18px' }}>
						{(()=>{
						const createAnother = <a style={{ textDecoration: 'none' }}>
							<Button
								variant="contained"
								color="primary"
								onClick={() => {
									let defaultFromData: any = null;
									let typeToSend = type;

									if (type === 'question') {
										
										defaultFromData = getDefaultFormData(subType)
										defaultFromData.questionCode = parseInt(subType)
										_.get(this.props.contentSubtype, "question", []).forEach(st => {
											if (subType == parseInt(st.code)) {
												defaultFromData.questionType = st.name;
											}
										});
										defaultFromData.specialPurposes = Object.values(CONTENT_SECTION_KEYS).filter(value => (content.specialPurposes || []).includes(value));
									} else {
										defaultFromData = getDefaultFormData()
									}
									if (type == "testpapers") {
										defaultFromData.settings.testType = subType
										defaultFromData.specialPurposes = Object.values(CONTENT_SECTION_KEYS).filter(value => (content.specialPurposes || []).includes(value));
									}
									if(type === 'studymaterial'){
										defaultFromData = initialNotesData;
										typeToSend = subType;
										if(subType === 'notes') {
											typeToSend = 'note'

											if (noteSubType) {
												defaultFromData.subType = noteSubType;
												defaultFromData.title = getTypeOfNotes(noteSubType);
											}	
										}
									}
									contentService.save('', typeToSend, defaultFromData, false)
										.then((res: any) => {
											let id = res.responseObject._id;
											if(type === 'studymaterial' && subType !== 'formulas') {
												id=res.responseObject.note._id;	
											}
											window.location.replace(`/content/edit/${type}/${subType}
										/${id}${typeToSend}`)
										})
								}}
								style={{ marginRight: '16px', }}
							>
								Create Another {isQuestion && (titleCase(type))}
							</Button>
						</a>
						const backToMyLibrary =fromTest
							? (
								<MyPATLink to={backTo} onClick={this.forceUpdate}>
									<Button variant="outlined" color="primary" onClick={() => togglePublishDialogOpen()}>Back to Test Paper</Button>
								</MyPATLink>
							) : (
								<a>
									<Button variant="outlined" color="primary" onClick={() => window.close()}>Back to My Library</Button>
								</a>
							)
							const sequenceList = isQuestion ? [backToMyLibrary, createAnother] : [createAnother, backToMyLibrary];
							return sequenceList.map(data => <>
								{data}
							</>);
						})()}
					</div>
				</MyPATDialog>
			</div>
		);
	}
}

const mapStateToProps = (state: any) => ({
	users: _.get(state, 'mylibraryData.users.list', []),
	userData: state.loginData.userData,
	contentSubtype: _.get(state, 'mylibraryData.contentSubtype', {}),
	draftIdForQuestion: _.get(state, 'questionCreate.draftId', null),
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
	contentSubtypeByContentTypeCode: contentSubtypeActions.contentSubtypeByContentTypeCode,
	usersList
}, dispatch);

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ContentPublishedModal));

// export default withStyles(styles)(ContentPublishedModal);